import { parseIsoDate, parseServerInstant } from '@/utils/dateUtils';

/** The bare calendar day the handout response carries its period bounds in. */
const CALENDAR_DAY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * A date of the handout, read into the reader's own calendar.
 *
 * The period bounds arrive as bare days, which `new Date` reads as UTC midnight — the day before,
 * anywhere west of Greenwich. The evaluation date arrives as the instant it is, and is read as one,
 * the way the evaluation step reads it.
 *
 * Undefined for a blank value and for anything that is not a date, so a caller can tell "no date"
 * from "a date I could not read" and keep showing what the document holds.
 */
export const parseHandoutDate = (value: string): Date | undefined => {
    if (!value) {
        return undefined;
    }

    if (CALENDAR_DAY.test(value)) {
        return parseIsoDate(value);
    }

    return parseServerInstant(value);
};
